<template>
  <div v-if="isLoggedIn" class="card">
    <Toast />
    <form @submit.prevent="save">
      <Toolbar>
        <template v-slot:right>
          <Button
            label="Guardar"
            icon="pi pi-save"
            type="submit"
            @click="submitForm()"
            class="p-button-raised p-button-rounded"
          />
        </template>
      </Toolbar>
      <Divider align="left">
        <div class="p-d-inline-flex p-ai-center">
          <i class="pi pi-id-card p-mr-1"></i>
          <h3>Datos</h3>
        </div>
      </Divider>
      <div class="p-formgroup-inline">
        <div class="form-control" :class="{ invalid: !codigo.isValida }">
          <span class="p-float-label">
            <InputText
              id="codigo"
              type="text"
              @blur="clearValidity('codigo')"
              :maxlength="100"
              size="53"
              v-model="codigo.val"
              @keydown="validateKey"
            />

            <label for="codigo">Código</label>
          </span>
        </div>
      </div>
      <div><br /></div>
      <div class="p-formgroup-inline">
        <div class="form-control" :class="{ invalid: !descripcion.isValida }">
          <span class="p-float-label">
            <InputText
              id="descripcion"
              type="text"
              @blur="clearValidity('descripcion')"
              :maxlength="100"
              size="53"
              v-model="descripcion.val"
            />
            <label for="descripcion">Descripción</label>
          </span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  emits: ['save-data'],
  data() {
    return {
      formIsValida: true,
      error: null,
      codigo: { val: '', isValida: true },
      descripcion: { val: '', isValida: true },
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    clearValidity(input) {
      this[input].isValida = true;
    },
    validateKey(event) {
      const allowedKeys = [
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Tab',
      ]; // Teclas permitidas
      const isNumber = /^[0-9]$/.test(event.key); // Verifica si el carácter es un número
      if (!isNumber && !allowedKeys.includes(event.key)) {
        event.preventDefault(); // Bloquea cualquier otra tecla
      }
    },
    submitForm() {
      this.validForm();

      if (!this.formIsValida) {
        this.$toast.add({
          severity: 'error',
          summary: 'Campos Incorrectos',
          detail: 'Por favor revisar que los campos se encuentren correctos',
          life: 3000,
        });
        return;
      }
      const dataUser = {
        codigo: this.codigo.val,
        descripcion: this.descripcion.val,
      };
      console.log(dataUser);
      this.$emit('save-data', dataUser, null);
      setTimeout(() => {}, 500);
    },
    validForm() {
      this.formIsValida = true;
      if (this.codigo.val === '') {
        this.formIsValida = false;
        this.codigo.isValida = false;
      }
      if (this.descripcion.val === '') {
        this.formIsValida = false;
        this.descripcion.isValida = false;
      }
    },
  },
};
</script>
